import { ark as m } from "@ark-ui/react";
import { styled as c } from "@huspy/styled-system/jsx";
import { propertyChip as h } from "@huspy/styled-system/recipes";
import t from "react";
const f = c(m.div, h);
function x(l) {
  const { children: n, leftSection: e, rightSection: i, ...p } = l;
  let r = null, o = null;
  return t.isValidElement(e) && (r = t.cloneElement(e, { width: "16px", height: "16px" })), t.isValidElement(i) && (o = t.cloneElement(i, { width: "16px", height: "16px" })), /* @__PURE__ */ t.createElement(f, { ...p }, r, n, o);
}
export {
  x as PropertyChip
};
